import {Component} from 'react'

import formFieldFactory from '../formFieldFactory'
import Input from './Input'


class Url extends Component {
  value() { return this.refs.formInput.value() }

  render() { return <Input {...this.props} ref='formInput' type='url' /> }
}

export default formFieldFactory(<Url />)
